import React, { CSSProperties } from "react";
import { countdownTimerColors, countdownTimerUnits } from "../../constants/countdown-timer";

type Props = {
    totalMinutes: number,
    remainingMinutes: number,
    size: number,
    strokeWidth: number,
    codeTimeoutHandler: () => void,
    updateTimeFormat: () => void,
};

type State = {
    countdown: number,
    isPlaying: boolean,
    strokeBgColor: string,
    strokeColor: string,
    hasUpdatedTimeFormat: boolean, 
};

export default class CountdownTimer extends React.Component<Props, State>{
    totalMilliseconds: number;
    remainingMilliseconds: number;
    radius: number;
    circumference: number;
    timeDangerChangePoint: number;
    strokeDashoffset: () => number;
    
    constructor(props:Props) {
		super(props);

        this.totalMilliseconds = this.props.totalMinutes * countdownTimerUnits.ONE_MINUTE_IN_MILLI;
        this.remainingMilliseconds = this.props.remainingMinutes * countdownTimerUnits.ONE_MINUTE_IN_MILLI;
        this.radius = this.props.size / 2;
        this.circumference = this.props.size * Math.PI;
        this.timeDangerChangePoint = (this.totalMilliseconds) / 3;

		this.state = {
            countdown: this.remainingMilliseconds - countdownTimerUnits.ONE_SECOND_IN_MILLI,
            isPlaying: true,
            strokeBgColor: countdownTimerColors.COUNTDOWN_TIMER_BG_GREEN,
            strokeColor: countdownTimerColors.COUNTDOWN_TIMER_GREEN,
            hasUpdatedTimeFormat: false,
		}

        this.strokeDashoffset = () => this.circumference - (this.state.countdown / this.totalMilliseconds) * this.circumference;
	}

    componentDidMount() {
        const interval = setInterval(() => {
            const countdownCopy = this.state.countdown - countdownTimerUnits.ONE_SECOND_IN_MILLI;

            if(countdownCopy > 0) {
                if ((countdownCopy < countdownTimerUnits.ONE_MINUTE_IN_MILLI) && !this.state.hasUpdatedTimeFormat) {
                    this.props.updateTimeFormat();
                    this.setState({ hasUpdatedTimeFormat: true });
                    
                }
                if(countdownCopy > this.timeDangerChangePoint) {
                    this.setState({countdown: countdownCopy});
                } else {
                    this.setState({
                        countdown: countdownCopy,
                        strokeColor: countdownTimerColors.COUNTDOWN_TIMER_RED,
                        strokeBgColor: countdownTimerColors.COUNTDOWN_TIMER_BG_RED
                    })
                }
            } else if(countdownCopy === 0) {
                clearInterval(interval);
                this.setState({
                   countdown: 0,
                   isPlaying: false,
                   strokeColor: "",
                });
                this.props.codeTimeoutHandler();
            }
        }, countdownTimerUnits.ONE_SECOND_IN_MILLI);
    }

    formatTime(milliseconds: number) {
        const minutes = Math.floor(milliseconds / countdownTimerUnits.ONE_MINUTE_IN_MILLI);
        const seconds: any = Math.floor(milliseconds % countdownTimerUnits.ONE_MINUTE_IN_MILLI / countdownTimerUnits.ONE_SECOND_IN_MILLI);

        if(minutes >= 1) {
            return `${minutes + 1}`;
        } else if(seconds > 0 ) {
            return seconds;
        } else {
            return '0';
        }
    }


	render() {

        const countdownSizeStyles = {
            height: this.props.size,
            width: this.props.size - 5,
        };
    
        const textStyles = {
            fontSize: this.props.size * 0.5,
            fontWeight: 700,
        };

        const minutes = this.formatTime(this.state.countdown);
        
		return (
            <>
                <div
                    style={Object.assign(
                        {},
                        countdownContainer,
                        countdownSizeStyles
                    )}
                >
                    <p style={textStyles}>{minutes}</p>
                    <svg style={countdownSvg}>
                        <circle
                        cx={this.radius}
                        cy={this.radius}
                        r={this.radius}
                        fill="none"
                        stroke={this.state.strokeBgColor}
                        strokeWidth={this.props.strokeWidth}
                        ></circle>
                    </svg>
                    <svg style={countdownSvg}>
                        <circle
                        strokeDasharray={this.circumference}
                        strokeDashoffset={
                            this.state.isPlaying ? this.strokeDashoffset() : 0
                        }
                        r={this.radius}
                        cx={this.radius}
                        cy={this.radius}
                        fill="none"
                        strokeLinecap="round"
                        stroke={this.state.strokeColor}
                        strokeWidth={this.props.strokeWidth}
                        ></circle>
                    </svg>
                </div>
            </>     
		);
	}
}

const countdownSvg: CSSProperties = {
    position: "absolute",
    bottom: 5,
    left: 0,
    width: "100%",
    height: "100%",
    transform: "rotateY(-180deg) rotateZ(-90deg)",
    overflow: "visible",
};

const countdownContainer: CSSProperties = {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    margin: "auto",
}